import React from 'react';
import styled from '../../../../../lib/styles';
import spacerBlockStyles from './SpacerBlock_styles';
import { compose } from 'recompose';

export interface SpacerBlockData {
  type: 'spacer_block' | 'acf_spacer_block';
  desktop_spacing: string;
  mobile_spacing: string;
}

export interface SpacerBlockProps {
  block: SpacerBlockData;
}

export const SpacerBlock = ({ 
  // block, 
  styles 
}) => {
  // console.log('SpacerBlock', block);
  return <div className={`spacer-block ${styles.container}`}></div>;
};

export default compose(styled(spacerBlockStyles))(SpacerBlock);